import {useTranslation} from "@i18n/client";
import React, {PropsWithChildren} from "react";

const RegionFilter: React.FC<PropsWithChildren<unknown>> = ({children}) => {
  const i18n = useTranslation();

  return (
    <div className="tac ma pb8 pb0-md">
      <span className="font-i fs24 fs18-sm lh13 gray600 mb4 db">
        {i18n.t("Choose your region")}
      </span>
      {children}
    </div>
  );
};

export default RegionFilter;
